<template>
  <div>
    <div class="footer color-f">
      <div class="footer-left">
        <div class="color-f">
          <p class="footer-left-title">考不倒智慧课堂</p>
          <p class="footer-left-en">Super Teacher Super Kids</p>
        </div>
        <p class="footer-left-desc">快速突破词汇量，让你的成绩飞起来</p>
        <p class="footer-left-mobile">15800978351 彭老师</p>
      </div>
      <div class="footer-middle clear-fix">
        <div class="pull-left w_33" v-for="item in list">
          <h1>{{item.title}}</h1>
          <i></i>
          <p>{{item.desc}}</p>
          <p>{{item.txt}}</p>
        </div>
      </div>
      <div class="footer-right">
        <div class="w_70 marginCenter" style="">
          <img :src="$url.wx_qrcode" alt="" class="w_100" />
          <p style="color: #333">扫码注册，开通即用</p>
        </div>
      </div>
    </div>

    <div class="color-f record" style="background: #000">
      <p>Copyright © 考不倒速学英语教研室 版权所有  <br><a href="http://www.beian.miit.gov.cn/" class="color-f">沪ICP备19018896号-1</a>
        <br> 总部地址：上海市曹安路1909号</p>
    </div>
    <div class="com_block"></div>
  </div>
</template>

<script>
  export default {
    name: "commonFooter",
    data(){
      return{
        list:[
          {title: '快速响应',desc:'专职教师全程辅导',txt: '快速响应及时答疑'},
          {title: '方便高效',desc: '线上线下结合',txt: '科技赋能教学'},
          {title: '坚守品质',desc: '金牌名师授课',txt: '承诺考试成绩'},
        ]
      }
    }
  }
</script>

<style scoped>
  .w_33{
    width: 33.33%;
  }
  .footer{
    background: rgb(36,35,51);
    /*margin-top: 3rem;*/
    display: flex;
    padding: 1rem 4rem;
  }
  .footer .footer-left,.footer .footer-right{
    width: 5rem;
  }
  .footer-left{
    color: #ccc;
    font-size: 0.5rem;
  }
  .footer-left p{
    margin-top: 0.325rem;
  }
  .footer-left-title{
    font-size: 0.7rem;
    margin-top: 0!important;
  }
  .footer-left-en,.footer-right{
    font-size: 0.4rem;
  }
  .footer-left-desc,.footer-left-phone{
    font-size: 0.3rem;
  }
  .footer-left-mobile{
    font-size: 0.3rem;
    color: #fff;
  }
  .footer .footer-middle{
    flex-grow: 1;
    text-align: left;
    font-size: 0.2rem;
    padding-top: 1.5rem;
    padding-left: 1rem;
  }
  .footer-middle h1{
    font-weight: initial;
    margin-bottom: 0.3rem;
  }
  .footer-middle p{
    font-size: 0.3rem;
    line-height: 0.8rem;
  }
  .footer-middle i{
    width: 20%;
    height: 0.08rem;
    background: #10a9d1;
    display: block;
    margin-bottom: 0.2rem;
  }
  .footer-right p{
    color: rgb(51, 51, 51);
    text-align: center;
    font-size: 0.3rem;
    font-weight: bold;
  }
  .footer-right>div{
    background: #Fff;
    padding-bottom: 0.2rem;
  }
  .record{
    font-size: 0.26rem;
    text-align: center;
    padding: 0.3rem 0;
  }
  .record br{
    display: none;
  }
  .record a:hover{
    color: #00a0e9;
  }
  @media only screen and (max-width: 767px) {
    .com_block{
      display: block!important;
      height: 1.01rem;
    }
    .footer {
      padding: 0;
      /*margin-top: 1rem;*/
      display: block;
    }
    .footer-middle>div, .footer-left, .footer-right{
      width: 100% !important;
    }

    .footer .footer-left{
      text-align: center;
      padding-top: 0.5rem;
    }
    .footer .footer-middle{
      padding: 0;
    }
    .footer-middle>div{
      text-align: center;
      margin-top: 0.5rem;
    }
    .footer-middle i{
      margin: 0 auto;
    }
    .footer-middle{
      display: none;
    }
    .footer-right>div{
      width: 40%;
    }
    .footer-right{
      margin-top: 1rem;
      padding-bottom: 1rem;
    }
    .record{
      font-size: 0.2rem;
      line-height: 0.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/common/footer.vue